import { useEffect, useRef, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Breadcrumb } from "rsuite";
import { Button, GarageDetailCard } from "../../components";
import { ButtonType } from "../../components/button";
import CustomLoader from "../../components/loader";
import { garageCartSelector } from "../../redux/garageCart";
import { getLocalized } from "../../redux/localization";
import SummaryCard from "./summary-card";
const AlwaysScrollToBottom = () => {
  const elementRef = useRef(null);
  useEffect(() =>
    //@ts-ignore
    elementRef.current.scrollIntoView()
  );
  return <div ref={elementRef} />;
};
const GaragePage = () => {
  const localize = useSelector(getLocalized);
  const garageCart = useSelector(garageCartSelector);
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  return (
    <>
      <AlwaysScrollToBottom />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          paddingBlockEnd: 90,
        }}
      >
        <div className="container" style={{ marginBlockStart: 19 }}>
          <div className="w-100 d-flex justify-content-between my-2">
            <h2 className="header-font">
              <div className="breadcrumb">
                <Breadcrumb>
                  <Breadcrumb.Item href="/" className="breadCrumbText">
                    {localize.getString("home")}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item href="/cars" className="breadCrumbText">
                    {localize.getString("allcars")}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active className="breadCrumbText">
                    {localize.getString("cardetail")}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </h2>
            <Button
              buttonType={ButtonType.new}
              icon={<BsArrowRight />}
              title={"TÜM ARAÇLARI GÖSTER"}
              onClick={() => {
                history.push(`/cars`);
              }}
            />
          </div>
          <div
            className="divider-div garage-content"
            style={{ marginBlockStart: 15 }}
          >
            <div className="w-100">
              {loader && <CustomLoader />}
              <div
                style={{
                  backgroundColor: "#f4f4f4",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: 783,
                  height: 88,
                  paddingInline: "18px 10px",
                  marginBlockEnd: 20,
                }}
                className="garage-ad"
              >
                <p className="garageTitle">{localize.getString("garagead")}</p>
                <Button
                  buttonType={ButtonType.newColored}
                  icon={<BsArrowRight />}
                  title={localize.getString("addnewcar")}
                  onClick={() => {
                    history.push(`/cars`);
                  }}
                />
              </div>
              {garageCart.map((garageCartItem, i) => (
                <GarageDetailCard
                  key={i}
                  setLoader={setLoader}
                  data={garageCartItem}
                />
              ))}{" "}
            </div>

            <div>
              <SummaryCard isCreate={true} data={garageCart} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GaragePage;
